(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mbg-delivery-estimate"] && !Shopify.designMode) return;
  try {
    (() => {
  function computeDeliveryEstimate(now, config) {
    const nowMs = now instanceof Date ? now.getTime() : NaN;
    if (!Number.isFinite(nowMs)) throw new TypeError('now must be a valid Date');
    if (!config || typeof config.timeZone !== 'string' || !config.timeZone) {
      throw new TypeError('A timeZone is required');
    }
    const cutoffs = config.cutoffs;
    if (!Array.isArray(cutoffs) || cutoffs.length !== 7 ||
        !Array.from(cutoffs).every(value => value === null ||
          (Number.isInteger(value) && value >= 0 && value < 1440)) ||
        !cutoffs.some(value => value !== null)) {
      throw new RangeError('cutoffs must contain seven local-minute values or null, with at least one dispatch day');
    }
    if (!Array.isArray(config.deliveryDays) || !config.deliveryDays.length ||
        !Array.from(config.deliveryDays).every(day => Number.isInteger(day) && day >= 0 && day <= 6)) {
      throw new RangeError('deliveryDays must contain weekday numbers from 0 to 6');
    }
    if (config.excludedDates !== undefined && !Array.isArray(config.excludedDates)) {
      throw new TypeError('excludedDates must be an array of YYYY-MM-DD strings');
    }
  
    const dayMs = 86400000;
    const minuteMs = 60000;
    const formatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: config.timeZone, calendar: 'gregory', numberingSystem: 'latn',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    });
    const civilUtc = (year, month, day, hour = 0, minute = 0, second = 0) => {
      const value = new Date(0);
      value.setUTCFullYear(year, month - 1, day);
      value.setUTCHours(hour, minute, second, 0);
      return value.getTime();
    };
    const localParts = instant => {
      const result = {};
      for (const part of formatter.formatToParts(instant)) {
        if (part.type !== 'literal') result[part.type] = Number(part.value);
      }
      return result;
    };
    const wallUtc = instant => {
      const part = localParts(instant);
      return civilUtc(part.year, part.month, part.day, part.hour, part.minute, part.second);
    };
    const dateKey = civilDay => new Date(civilDay).toISOString().slice(0, 10);
    const excluded = new Set(config.excludedDates || []);
    for (const key of excluded) {
      if (typeof key !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(key)) {
        throw new RangeError('Excluded dates must use YYYY-MM-DD');
      }
      const [year, month, day] = key.split('-').map(Number);
      if (year < 1 || dateKey(civilUtc(year, month, day)) !== key) {
        throw new RangeError('Excluded dates must be real Gregorian dates');
      }
    }
    const cutoffInstant = (civilDay, minutes) => {
      const targetWall = civilDay + minutes * minuteMs;
      const offsets = new Set([-dayMs, 0, dayMs].map(delta => {
        const sample = targetWall + delta;
        return wallUtc(sample) - sample;
      }));
      const matches = [];
      for (const offset of offsets) {
        const candidate = targetWall - offset;
        if (wallUtc(candidate) === targetWall) matches.push(candidate);
      }
      if (!matches.length) throw new RangeError('Dispatch cutoff does not exist in the configured time zone');
      return Math.min(...matches);
    };
  
    const current = localParts(nowMs);
    if (current.year < 1 || current.year > 9998) throw new RangeError('Date is outside the supported calendar range');
    const today = civilUtc(current.year, current.month, current.day);
    const deliveryDays = new Set(config.deliveryDays);
    const limit = 7 * (excluded.size + 1) + 1;
    let dispatchDay;
    let cutoff;
    for (let offset = 0; offset <= limit; offset++) {
      const day = today + offset * dayMs;
      const minutes = cutoffs[new Date(day).getUTCDay()];
      if (minutes === null || excluded.has(dateKey(day))) continue;
      const candidate = cutoffInstant(day, minutes);
      if (candidate > nowMs) {
        dispatchDay = day;
        cutoff = candidate;
        break;
      }
    }
    if (dispatchDay === undefined) throw new RangeError('No eligible dispatch date found');
    for (let offset = 1; offset <= limit; offset++) {
      const day = dispatchDay + offset * dayMs;
      if (!deliveryDays.has(new Date(day).getUTCDay()) || excluded.has(dateKey(day))) continue;
      return {
        dispatchDate: dateKey(dispatchDay),
        deliveryDate: dateKey(day),
        cutoffUtc: new Date(cutoff).toISOString(),
        countdownMs: cutoff - nowMs,
        isTomorrow: day === today + dayMs
      };
    }
    throw new RangeError('No eligible delivery date found');
  }

  class MbgDeliveryEstimate extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;
      this.abortController = new AbortController();
      this.pending = false;
      const { signal } = this.abortController;
      this.dateNode = this.querySelector('[data-delivery-date]');
      this.noteNode = this.querySelector('[data-delivery-note]');
      this.countdownNode = this.querySelector('[data-delivery-countdown]');
      this.timerNode = this.querySelector('[data-delivery-timer]');
      try {
        this.messages = JSON.parse(this.dataset.messages);
        const parseCutoff = value => {
          if (!/^(?:[01]\d|2[0-3]):[0-5]\d$/.test(value)) throw new RangeError('Invalid cutoff');
          const [hours, minutes] = value.split(':').map(Number);
          return hours * 60 + minutes;
        };
        const weekday = parseCutoff(this.dataset.weekdayCutoff);
        const saturday = parseCutoff(this.dataset.saturdayCutoff);
        this.config = {
          timeZone: 'Europe/Sofia',
          cutoffs: [null, weekday, weekday, weekday, weekday, weekday, saturday],
          deliveryDays: [1, 2, 3, 4, 5, 6],
          excludedDates: this.dataset.closedDates.split(/[,;\s]+/).filter(Boolean)
        };
        const locale = this.dataset.locale || 'bg';
        this.dateFormatter = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long', timeZone: 'UTC' });
        this.weekdayFormatter = new Intl.DateTimeFormat(locale, { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' });
        this.todayFormatter = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Sofia', year: 'numeric', month: '2-digit', day: '2-digit' });
        this.timeFormatter = new Intl.DateTimeFormat(locale, { timeZone: 'Europe/Sofia', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
      } catch {
        this.showFallback();
        return;
      }
      const scope = this.closest('main-product') || this.closest('.shopify-section');
      scope?.addEventListener('click', event => {
        const option = event.target.closest('variant-picker .variant-option');
        if (option) {
          this.pending = true;
          this.showFallback('pending');
        }
      }, { capture: true, signal });
      scope?.addEventListener('change', event => {
        if (event.target.closest('variant-picker')) {
          this.pending = true;
          this.showFallback('pending');
        }
      }, { signal });
      document.addEventListener(`maximize:variant-picker:updated:${this.dataset.sectionId}`, event => {
        cancelAnimationFrame(this.variantFrame);
        this.variantFrame = requestAnimationFrame(() => {
          if (!this.isConnected) return;
          this.pending = false;
          this.refreshVariant(event.detail);
        });
      }, { signal });
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) this.tick(true);
      }, { signal });
      const initialize = () => {
        this.refreshVariant();
        this.interval = setInterval(() => {
          if (!document.hidden) this.tick();
        }, 1000);
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize, { once: true, signal });
      } else {
        initialize();
      }
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
      clearInterval(this.interval);
      cancelAnimationFrame(this.variantFrame);
    }

    readJSON(prefix) {
      try {
        return JSON.parse(document.getElementById(`${prefix}__${this.dataset.sectionId}`)?.textContent || 'null');
      } catch {
        return null;
      }
    }

    refreshVariant(detail) {
      const variant = detail ? detail.currentVariant : this.readJSON('CurrentVariantInfo');
      this.eligible = variant?.available === true && variant.requires_shipping === true &&
        detail?.isOptionExist !== false && detail?.isOptionAvailable !== false;
      this.tick(true);
    }

    setText(node, value) {
      if (node.textContent !== value) node.textContent = value;
    }

    showFallback(state = 'fallback') {
      this.dataset.state = state;
      this.countdownNode.hidden = true;
      this.dateNode.removeAttribute('data-date');
      if (!this.messages) return;
      this.setText(this.dateNode, this.messages[`${state}Title`]);
      this.setText(this.noteNode, this.messages[`${state}Text`]);
    }

    tick(force = false) {
      if (!this.config || this.pending) return;
      if (!this.eligible) {
        this.showFallback('unavailable');
        return;
      }
      try {
        const now = new Date();
        const todayParts = this.todayFormatter.formatToParts(now);
        const part = type => todayParts.find(value => value.type === type).value;
        const today = `${part('year')}-${part('month')}-${part('day')}`;
        if (force || !this.estimate || today !== this.today || now.getTime() >= Date.parse(this.estimate.cutoffUtc)) {
          this.estimate = computeDeliveryEstimate(now, this.config);
          this.today = today;
          const civilDate = new Date(`${this.estimate.deliveryDate}T12:00:00Z`);
          const dateText = this.estimate.isTomorrow
            ? this.messages.tomorrow.replace('__DATE__', this.dateFormatter.format(civilDate))
            : this.weekdayFormatter.format(civilDate);
          const cutoffText = this.timeFormatter.format(new Date(this.estimate.cutoffUtc));
          const dispatchText = this.estimate.dispatchDate === today
            ? this.messages.today.replace('__TIME__', cutoffText)
            : this.messages.later.replace('__DATE__', this.weekdayFormatter.format(new Date(`${this.estimate.dispatchDate}T12:00:00Z`))).replace('__TIME__', cutoffText);
          this.setText(this.dateNode, dateText);
          this.dateNode.dataset.date = this.estimate.deliveryDate;
          this.setText(this.noteNode, dispatchText);
        }
        const minutes = Math.max(0, Math.ceil((Date.parse(this.estimate.cutoffUtc) - now.getTime()) / 60000));
        const days = Math.floor(minutes / 1440);
        const hours = Math.floor(minutes % 1440 / 60);
        const remainder = minutes % 60;
        const pad = value => String(value).padStart(2, '0');
        this.setText(this.timerNode, `${days ? `${days} ${this.messages.day} ` : ''}${pad(hours)} ${this.messages.hour} ${pad(remainder)} ${this.messages.minute}`);
        this.dataset.state = 'eligible';
        this.countdownNode.hidden = false;
      } catch {
        this.showFallback();
      }
    }
  }
  if (!customElements.get('mbg-delivery-estimate')) customElements.define('mbg-delivery-estimate', MbgDeliveryEstimate);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mbg-installation-request"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mbg-installation-request')) {
    customElements.define('mbg-installation-request', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.checkbox = this.querySelector('[data-mbg-installation-request]');
        this.marker = this.querySelector('[data-mbg-installation-marker]');
        this.sync = () => { this.marker.disabled = !this.checkbox.checked; };
        this.checkbox.addEventListener('change', this.sync, options);
        this.checkbox.form?.addEventListener('formdata', event => {
          if (this.checkbox.checked) event.formData.set(this.marker.name, this.marker.value);
          else event.formData.delete(this.marker.name);
        }, options);
        this.checkbox.form?.addEventListener('reset', () => queueMicrotask(this.sync), options);
        window.addEventListener('pageshow', this.sync, options);
        this.sync();
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mbg-product-purchase-layout"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mbg-compatibility-placement')) {
    customElements.define('mbg-compatibility-placement', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => {
          this.card = this.querySelector('.mbg-product-compatibility');
          this.benefits = this.closest('product-info.mbg-split-purchase')?.querySelector('.mbg-product-purchase-row .mbg-product-benefits');
          if (!this.card || !this.benefits) return;

          this.desktop = matchMedia('(min-width: 1024px)');
          this.place = () => {
            const destination = this.desktop.matches ? this.benefits : this;
            if (this.card.parentElement !== destination) destination.prepend(this.card);
          };
          this.desktop.addEventListener('change', this.place);
          this.place();
        });
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.desktop?.removeEventListener('change', this.place);
        if (this.card && !this.contains(this.card)) this.append(this.card);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
